import type { FaireProductEntity } from "../../entity_types/product";

export const p_yhxxg6add3: FaireProductEntity = {
  token: "p_yhxxg6add3",
  type: "product",
  name: "Have a Magical Birthday Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/4f4675678edfd05376ebd444077199d86933d43f9adf96cf9f4ceddc1cfa34f0.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.13,
  description:
    'Summon the enchantment of a magical birthday with our "Have a Magic Birthday" Greeting Card! Inspired by the whimsical world of Harry Potter, this card brings a touch of spellbinding charm to any birthday celebration. Whether you\'re sending it to a fellow sorcerer or to anyone in need of a little birthday magic, this card is sure to dazzle and delight. With its captivating design and empowering message, it\'s the perfect way to spread birthday joy and remind them of the magic within. So, let your wishes sparkle and shine with this delightful greeting card!\n\n• Size: A2, 5.5" x 4.25"\n• Features: Blank interior and coordinating envelope\n• Sentiment: Have a Magic Birthday',
  tags: [],
  msrpDollars: 8.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:01.407Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
